export const formatTimestamp = (timestamp: number | string) =>
  new Date(timestamp).toLocaleDateString("de-DE", {
    day: "2-digit",
    year: "numeric",
    month: "2-digit",
  });
